import React from 'react';
import {Dropdown} from 'react-bootstrap';
import './dropdown.style.scss';
import DropdownSelectItem from './selectItem';
import classNames from 'classnames';

type TDropdownBadgesProps<T> = {
  title: string;
  options: Array<T>;
  optionTitle: keyof T;
  selectedAttributes: Array<T>;
  setSelectedAttributes: React.Dispatch<React.SetStateAction<T[]>>;
  isGreen?: boolean;
};

const DropdownBadges = <T extends Record<string, string | number>>({
  title,
  options,
  optionTitle,
  selectedAttributes,
  isGreen,
  setSelectedAttributes,
}: TDropdownBadgesProps<T>) => {
  const AddItem = (item: T) => {
    if (!selectedAttributes?.some(x => x === item))
      setSelectedAttributes(prev => [...prev, item]);
  };
  const removeItem = (item: T) => {
    setSelectedAttributes(prev => prev.filter(x => x !== item));
  };

  return (
    <>
      <div
        className={classNames(
          isGreen ? 'dropdown-badges-isGreen' : 'dropdown-badges',
        )}
      >
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {title}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {React.Children.toArray(
              options?.map(item => (
                <Dropdown.Item onClick={() => AddItem(item)} href="">
                  <span>{item[optionTitle]}</span>
                </Dropdown.Item>
              )),
            )}
          </Dropdown.Menu>
        </Dropdown>
        <div className="d-flex mt-2">
          {React.Children.toArray(
            selectedAttributes?.map(item => (
              <DropdownSelectItem
                item={item}
                optionTitle={optionTitle}
                removeItem={e => removeItem(e)}
              />
            )),
          )}
        </div>
      </div>
    </>
  );
};

export default DropdownBadges;
